import { useEffect, useMemo, useState } from "react";
import {
  establishmentStatusOptions,
  establishmentTypeOptions,
  fetchEstablishmentFilterOptions,
} from "./establishmentFilters";

export default function useEstablishmentFilterOptions({
  t,
  provinceId = "",
  departmentId = "",
  subPrefectureId = "",
} = {}) {
  const [values, setValues] = useState({ types: [], statuses: [] });

  useEffect(() => {
    const controller = new AbortController();
    fetchEstablishmentFilterOptions(
      { provinceId, departmentId, subPrefectureId },
      controller.signal
    )
      .then(setValues)
      .catch((error) => {
        if (error?.name !== "CanceledError" && error?.name !== "AbortError") {
          console.error("Fetch establishment filter options error", error);
          setValues({ types: [], statuses: [] });
        }
      });
    return () => controller.abort();
  }, [provinceId, departmentId, subPrefectureId]);

  const typeOptions = useMemo(() => establishmentTypeOptions(t, values.types), [t, values.types]);
  const statusOptions = useMemo(
    () => establishmentStatusOptions(t, values.statuses),
    [t, values.statuses]
  );

  return {
    typeOptions,
    statusOptions,
  };
}
